import React from "react";

// Inline SVG matching the email-embedded mark. Used in the app header
// (EchoPage / share card) so the brand is consistent across product surfaces.
export const PostmanIcon = ({ size = 56, className = "", title = "MiProse" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 80 80"
    width={size}
    height={size}
    role="img"
    aria-label={title}
    className={className}
  >
    {/* crescent moon */}
    <path d="M54 16 a8 8 0 0 0 8 8 a10 10 0 1 1 -8 -8 z" fill="#1C1A17" opacity="0.85" />
    {/* tiny stars */}
    <circle cx="22" cy="18" r="1.1" fill="#8A3A33" />
    <circle cx="34" cy="12" r="0.9" fill="#8A3A33" opacity="0.7" />
    <circle cx="14" cy="28" r="0.8" fill="#1C1A17" opacity="0.45" />
    {/* envelope */}
    <rect x="12" y="34" width="56" height="32" rx="1.5" fill="#F9F6F0" stroke="#1C1A17" strokeWidth="1.4" />
    <path d="M12 34 L40 54 L68 34" fill="none" stroke="#1C1A17" strokeWidth="1.4" />
    {/* wax seal */}
    <circle cx="40" cy="54" r="4" fill="#8A3A33" />
    <circle cx="40" cy="54" r="1.5" fill="#F9F6F0" opacity="0.45" />
  </svg>
);

export default PostmanIcon;
